// import { viewPorts } from '@/constants/viewPorts'

const CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE = [
    {
        name: 'Number',
        value: 'number',
        disabled: true,
        grow: true,
        minWidth: 100,
    },
    {
        name: 'Type',
        value: 'type',
        align: 'center',
        activeDefault: true,
        minWidth: 80,
        padding: 'px-1',
    },
    {
        name: 'Name',
        value: 'name',
        disabled: true,
        grow: true,
        minWidth: 70,
    },
    {
        name: 'Vendor',
        value: 'vendor',
        grow: true,
        minWidth: 80,
    },
    {
        name: 'Payout',
        value: 'payout',
        minWidth: 70,
    },
    {
        name: 'Live',
        value: 'live',
        align: 'center',
        activeDefault: false,
        insertContent: true,
        minWidth: 70,
    },
    {
        name: 'Hourly',
        value: 'hourly_revenue_cap',
        align: 'center',
        activeDefault: false,
        insertContent: true,
        minWidth: 70,
    },
    {
        name: 'Daily',
        value: 'daily_revenue_cap',
        align: 'center',
        activeDefault: false,
        insertContent: true,
        minWidth: 70,
    },
    {
        name: 'Monthly',
        value: 'monthly_revenue_cap',
        align: 'center',
        activeDefault: false,
        insertContent: true,
        minWidth: 70,
    },
    {
        name: 'Global',
        value: 'global_revenue_cap',
        align: 'center',
        activeDefault: false,
        insertContent: true,
        minWidth: 70,
    },
    {
        name: 'Status',
        value: 'status',
        align: 'center',
        minWidth: 80,
    },
]

const CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE_WITH_ACTIONS = [
    ...CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE,
    {
        name: 'Actions',
        value: 'actions',
        minWidth: 74,
        align: 'center',
        disabled: true,
        insertContent: true,
        // sticky: true,
        // right: viewPorts.mb >= window.innerWidth ? -1 : 0,
    },
]

export {
    CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE, CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE_WITH_ACTIONS,
}
